import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import io from 'socket.io-client';

import './Pvstatus.css';
import MainCenterGaugeChart from './MainCenterGaugeChart';
import MainBottomVerticalGaugeGraph from './MainBottomVerticalGaugeGraph';
import MainEnSensor from './MainEnSensor';
import MainWindSensor from './MainWindSensor';
import MainRelayControl from './MainRelayControl';

import Sunrise from '../../image/icons/sunrise.png';
import Sunset from '../../image/icons/sunset.png';
import Timeicon from '../../image/icons/timeicon.png';
import Tempicon from '../../image/icons/temp.png';

import { updateTime } from '../../store';
import config from '../../config';
import useIsMobile from '../../hooks/useIsMobile';


const socket = io(`${config.backendUrl}`, {
  transports: ['websocket']
}); // 웹소켓 서버 URL

function Pvstatus() {
  const dispatch = useDispatch();
  const systemTime = useSelector((state) => state.systemTime);
  const evData = useSelector((state) => state.evData || {});
  const ivCapa = useSelector((state) => state.Iv_list?.iv_capa || []);
  const isMobile = useIsMobile();

  const [gaugeData] = useState({
    gaugeRatio: [60, 40],
    BottomTitle: '발전전력',
    gaugeValue: 50, // 기본값
    gaugeMaxValue: 100 // 기본값
  });

  const [prevMonthPower, setPrevMonthPower] = useState({ value: 0, unit: 'kWh' });

  const totalCapa = Array.isArray(ivCapa)
    ? ivCapa.reduce((acc, val) => acc + (Number(val) || 0), 0)
    : 0;

  useEffect(() => {
    fetch(`${config.backendUrl}/api/prev-month-generation`, { method: 'GET' })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'success') {
          setPrevMonthPower({
            value: data.prev_month_generation,
            unit: 'kWh',
          });
        }
      })
      .catch((err) => console.error('전일 발전량 API 오류:', err));
  }, []);
  // RegisterEvSensor.temperature_raw (첫 번째 센서 값)
  const temperatureRaw =
    Array.isArray(evData.temperature_raw) && evData.temperature_raw.length > 0
      ? evData.temperature_raw[0]
      : 0;

  // WH-2300S 기상 데이터 (첫 번째 센서 기준)
  const windSensorData = {
    illuminance: evData.light?.[0] ?? evData.light_lux?.[0] ?? 0,
    uv: evData.uv_index?.[0] ?? 0,
    windDirection: evData.wind_direction?.[0] ?? 0,
    windSpeed: evData.wind_speed_mps?.[0] ?? 0,
    rainfall: evData.rainfall?.[0] ?? evData.rainfall_mm?.[0] ?? 0,
    humidity: evData.humidity?.[0] ?? 0,
  };
  useEffect(() => {
    socket.on('connect', () => {
      // console.log('Connected to WebSocket server');
    });

    socket.on('system_time', (data) => {
      if (data.nowtime) {
        dispatch(updateTime(data)); // Redux 상태 업데이트
        // console.log('Redux 시간 업데이트', data);
      }
    });

    const interval = setInterval(() => {
      socket.emit('request_time');
    }, 1000);

    return () => {
      clearInterval(interval);
      socket.off('system_time');
      socket.off('connect');
    };
  }, [dispatch]);

  const { nowtime, sunrise, sunset } = systemTime;

  let datePart = '';
  let timePart = '';

  if (nowtime) {
    datePart = nowtime.substring(0, nowtime.indexOf(')') + 1);
    timePart = nowtime.substring(nowtime.indexOf(')') + 2);
  } else {
    // 기본값 설정
    datePart = 'Loading date...';
    timePart = 'Loading time...';
  }

  return (
    <div className='main-Public-wrap'>
      <div className='main-pvstatus-wrap'>
        
        {/* 일출/일몰, 현재시간, 현재온도 — 1행 3열 (일정 gap) */}
        <div className="sunRiseSet-Time-container">
          {/* 일출/일몰 영역 */}
          <div className="sunRiseSet-Box">
            <div className="text-center" style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "x-large", fontWeight: "600" }}>
              ◎ 일출 / 일몰
            </div>
            <img src={Sunrise} width={isMobile ? "40" : "50"} height={isMobile ? "40" : "50"} alt="Sunrise" style={{ padding: "3px" }}/>
            <span style={{ color: "#6B7476", fontSize: isMobile ? "large" : "xx-large", fontWeight: "600" }}>
              {sunrise || "Loading..."}
            </span>
            <img src={Sunset} width={isMobile ? "40" : "50"} height={isMobile ? "40" : "50"} alt="Sunset" style={{ padding: "3px" }}/>
            <span style={{ color: "#6B7476", fontSize: isMobile ? "large" : "xx-large", fontWeight: "600" }}>
              {sunset || "Loading..."}
            </span>
          </div>

          {/* 현재 시간 영역 */}
          <div className="sunRiseSet-Box">
            <img src={Timeicon} width="35" height="35" alt="Timeicon" />
            <span style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "x-large", fontWeight: "600" }}>
              현재 시간
            </span>
            <span style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "xx-large", fontWeight: "600" }}>
              {datePart}
            </span>
            <span style={{ color: "#6B7476", fontSize: isMobile ? "medium" : "xx-large", fontWeight: "600" }}>
              {timePart}
            </span>
          </div>

          {/* 현재 온도 영역 */}
          <div className="sunRiseSet-Box--temp">
            <img src={Tempicon} width="35" height="35" alt="Tempicon" />
            <span className="sunRiseSet-Box--temp-label">현재 온도</span>
            <span className="sunRiseSet-Box--temp-value">{temperatureRaw}</span>
          </div>
        </div>
        
        
        {/* 발전량 그래프, 기상센서 — 1행 배치 */}
        <div className={`chart-container pvstatus-main-row${isMobile ? ' is-mobile' : ''}`}>
          {/* 현재전력 / 금일발전량 / 변환효율 — 하나의 카드 */}
          <div className="gauge-panel-card">
            {/* 통합 제목박스 */}
            <div className="gauge-panel-card-title" style={{ borderBottom: '2px solid #DCE0EB' }}>
              <div>◎ 현재전력</div>
              <div style={{ flexGrow: '1' }}></div>
              <div style={{ marginLeft: '20px' }}>⦁ ⦁ ⦁</div>
            </div>

            <div className="gauge-panel-card-capacity">
              <div
                style={{
                  color: '#3D98DC',
                  fontSize: isMobile ? '13px' : '17px',
                  fontWeight: '700',
                  paddingLeft: '20px',
                }}
              >
                {`(모듈용량 - ${totalCapa.toFixed(2)} kW)`}
              </div>
            </div>

            <div className="gauge-panel-card-body">
              <div className="gauge-panel-item">
                <MainCenterGaugeChart dataType={'nowPower'} gaugeData={gaugeData} />
              </div>
              {/* <div className="gauge-panel-item">
                <MainCenterGaugeChart dataType={'todayPower'} gaugeData={gaugeData}/>
              </div>
              <div className="gauge-panel-item">
                <MainCenterGaugeChart dataType={'conEff'} gaugeData={gaugeData}/>
              </div> */}
            </div>
          </div>
          {/* 기상센서 */}
          <div className="gauge-panel-sensor">
            <MainEnSensor TopTitle={'기상센서'}/>
          </div>
          <div className="gauge-panel-sensor">
            <MainWindSensor title={'풍향 / 풍속'} data={windSensorData} />
          </div>
          <div className="gauge-panel-sensor">
            <MainRelayControl />
          </div>
        </div>
        {/* 하단 그래프 */}
        <div className='Vchart-container'>
          <MainBottomVerticalGaugeGraph prevMonthPower={prevMonthPower} />
        </div>
      </div>
    </div>
  );
}

export default Pvstatus;
